<template>
  <div>
    <a-card style="margin: 10px 20px 0 20px; padding: 20px">
      <a-row>
        <a-col
          :span="24"
          :lg="24"
          :xl="24"
          class="mb-24"
          style="display: flex; align-items: center; justify-content: flex-end"
        >
          <a-radio-group
            v-model:value="dateType"
            button-style="solid"
            @change="dateTypeChange"
            size="small"
          >
            <a-radio-button value="1">周</a-radio-button>
            <a-radio-button value="2">月</a-radio-button>
            <a-radio-button value="3">年</a-radio-button>
            <a-radio-button value="4">全部</a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>

      <div class="my-charts" ref="myChart"></div>
    </a-card>
  </div>
</template>

<script>
import { getChartBySearch } from "@/api/charts.js";
import { WCIOptions, WCITKOptions } from "./indexChartOpt.js";
export default {
  data() {
    return {
      WciKeytypeData: [],
      TkKeytypeData: [],
      ChartTitle: "自定义检索",
      dateType: "1",
      xAxisData: [],
      wcilegendData: [],
      tklegendData: [],
      seriesData: [],
      chartGrid: [],
      chartxAxis: [],
      chartyAxis: [],
      chartDataZoom: [],
      chartLegend: [],
    };
  },
  created() {
    this.parseQueryParams();
  },
  methods: {
    parseQueryParams() {
      const { queryJson, t, ...otherParams } = this.$route.query;
      if (queryJson) {
        alert("QueryJson:", queryJson);
        try {
          const parsedQuery = JSON.parse(queryJson);
          // 使用解析后的query对象
          this.loadDataWithQuery(parsedQuery);
        } catch (e) {
          console.error("Failed to parse queryJson:", e);
        }
      } else if (Object.keys(otherParams).length > 0) {
        // 这是使用方法1时的参数
        // 使用展开的query参数
        console.log(otherParams);
        this.loadDataWithQuery(otherParams);
      }
    },

    loadDataWithQuery(query) {
      if (query.parIds == null) {
        query.parIds = [];
      } else if (typeof query.parIds === "string") {
        // 如果是字符串，转换为单元素数组
        // 尝试解析JSON字符串（如果是通过序列化传递的数组）
        try {
          const parsed = JSON.parse(query.parIds);
          query.parIds = Array.isArray(parsed) ? parsed : [query.parIds];
        } catch (e) {
          // 如果解析失败，直接作为单元素数组
          query.parIds = [query.parIds];
        }
      } else if (!Array.isArray(query.parIds)) {
        // 如果不是null、字符串或数组，则转换为单元素数组
        query.parIds = [query.parIds];
      }
      // 实现使用query参数加载数据的逻辑
      getChartBySearch(query.skey, query.parIds).then((res) => {
        if (res.code == 0) {
          this.WciKeytypeData = res.data.wciInfos;
          this.TkKeytypeData = res.data.tkInfos;
          const wciuniqueKeyWord = [
            ...new Set(this.WciKeytypeData.map((item) => item.keyWord)),
          ];
          const tkuniqueKeyWord = [
            ...new Set(this.TkKeytypeData.map((item) => item.keyWord)),
          ];
          this.wcilegendData = wciuniqueKeyWord;
          this.tklegendData = tkuniqueKeyWord;
          this.SetDate();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    SetDate() {
      var ChartData = [];
      // 找到infoTime最大的值并去除对应项目
      if (this.WciKeytypeData.length > 0) {
        // 找到infoTime的最大值
        const maxInfoTime = Math.max(
          ...this.WciKeytypeData.map((item) => item.infoTime)
        );
        // 过滤掉infoTime等于最大值的项目
        const filteredData = this.WciKeytypeData.filter(
          (item) => item.infoTime !== maxInfoTime
        );

        if (this.dateType == "1") {
          ChartData = filteredData.slice(
            filteredData.length - 7 * this.wcilegendData.length,
            filteredData.length
          );
        } else if (this.dateType == "2") {
          ChartData = filteredData.slice(
            filteredData.length - 30 * this.wcilegendData.length,
            filteredData.length
          );
        } else if (this.dateType == "3") {
          ChartData = filteredData.slice(
            filteredData.length - 365 * this.wcilegendData.length,
            filteredData.length
          );
        } else {
          ChartData = filteredData;
        }
      } else {
        ChartData = [];
      }

      const uniqueInfoTimes = [
        ...new Set(ChartData.map((item) => item.infoTime)),
      ];
      this.xAxisData = uniqueInfoTimes;
      this.seriesData = this.wcilegendData.map((keyword) => {
        // 为每个keyword创建一个数据系列
        const dataByTime = {};

        // 初始化所有时间点的值为0
        uniqueInfoTimes.forEach((time) => {
          dataByTime[time] = 0;
        });

        // 填充实际数据
        ChartData.forEach((item) => {
          if (
            item.keyWord === keyword &&
            dataByTime.hasOwnProperty(item.infoTime)
          ) {
            dataByTime[item.infoTime] = item.totalScore || 0; // 假设数据中有关键字"value"字段
          }
        });

        // 将对象转换为按时间顺序排列的数组
        const values = uniqueInfoTimes.map((time) => dataByTime[time]);

        return {
          name: keyword,
          type: "line",
          stack: "Total",
          smooth: true,
          areaStyle: {},
          lineStyle: {
            width: 0,
          },
          showSymbol: false,
          emphasis: {
            focus: "series",
          },
          data: values,
        };
      });

      if (this.TkKeytypeData.length > 0) {
        // 找到所有符合uniqueInfoTimes的项目
        var tkChartData = this.TkKeytypeData.filter((item) =>
          uniqueInfoTimes.includes(item.infoTime)
        );
        var tkSeriesData = this.tklegendData.map((keyword) => {
          // 为每个keyword创建一个数据系列
          const dataByTime = {};
          uniqueInfoTimes.forEach((time) => {
            dataByTime[time] = 0;
          });
          // 填充实际数据
          tkChartData.forEach((item) => {
            if (
              item.keyWord === keyword &&
              dataByTime.hasOwnProperty(item.infoTime)
            ) {
              dataByTime[item.infoTime] = item.searchScore + item.topScore || 0;
            }
          });
          const tkval = uniqueInfoTimes.map((time) => dataByTime[time]);
          console.log(tkval);
          return {
            name: keyword,
            type: "line",
            stack: "Total1",
            smooth: true,
            areaStyle: {},
            xAxisIndex: 1,
            yAxisIndex: 1,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            emphasis: {
              focus: "series",
            },
            data: tkval,
          };
        });

        this.seriesData = [...this.seriesData, ...tkSeriesData];
      }

      if (this.TkKeytypeData.length > 0) {
        this.chartGrid = WCITKOptions.Grid;
        this.chartxAxis = WCITKOptions.xAxis;
        this.chartxAxis[0].data = this.xAxisData;
        this.chartxAxis[1].data = this.xAxisData;
        this.chartyAxis = WCITKOptions.yAxis;
        this.chartDataZoom = WCITKOptions.DataZoom;
        this.chartLegend = WCITKOptions.legend;
        this.chartLegend[0].data = this.wcilegendData;
        this.chartLegend[1].data = this.tklegendData;
      } else {
        this.chartGrid = WCIOptions.Grid;
        this.chartxAxis = WCIOptions.xAxis;
        this.chartxAxis[0].data = this.xAxisData;
        this.chartyAxis = WCIOptions.yAxis;
        this.chartDataZoom = WCIOptions.DataZoom;
        this.chartLegend = WCIOptions.legend;
        this.chartLegend[0].data = this.wcilegendData;
      }

      this.InitOptions();
    },
    dateTypeChange() {
      this.SetDate(); // 调用方法来重新获取数据并更新Grap
    },
    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myChart);
      this.chart.setOption({
        title: {
          text: this.ChartTitle,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          position: function (pos, params, el, elRect, size) {
            const obj = {
              top: 10,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          formatter: (params) => {
            if (!params || params.length === 0) return "";

            // 使用div包裹所有内容，添加基本样式
            let result = `<div style="padding: 8px;">`;

            // 添加标题，使用粗体和更大的字号
            result += `<div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">${params[0].name}</div>`;

            // 过滤并处理上图数据
            const wciTopParams = params.filter((item) => item.axisIndex === 0);
            if (wciTopParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = wciTopParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );

              // 添加每个数据项，使用flex布局对齐
              wciTopParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      WCI总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 关闭外层div
            result += `</div>`;
            return result;
          },
        },
        dataZoom: this.chartDataZoom,
        grid: this.chartGrid,
        legend: this.chartLegend,
        xAxis: this.chartxAxis,
        yAxis: this.chartyAxis,
        series: this.seriesData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-charts {
  width: 100%; // 设置宽度为100%，使其适应父容器
  height: 85vh; // 设置固定高度，可根据需要调整
}
</style>